module.exports = __webpack_public_path__ + "static/media/slide2.ac92d6dc.jpg";